import React from 'react'
import { useAcceptCookies } from '../utils/useAcceptedCookies'
import { Link, graphql, useStaticQuery } from 'gatsby'
// import { XMarkIcon } from '@heroicons/react/24/outline'
import { FiX } from "react-icons/fi";

export default function Alert() {
  const data = useStaticQuery(graphql`
    {
      allBlockContentAnnouncementBanner(limit: 1) {
        nodes {
          field_announcement_
          field_announcement_con
          field_announcement_link_label
          field_announcement_external_link {
            uri
          }
          changed
        }
      }
    }
  `)
  const changed = data?.allBlockContentAnnouncementBanner?.nodes[0]?.changed
  const { acceptedCookies, onAcceptCookies } = useAcceptCookies(`alert ${changed}`)
  if(!data?.allBlockContentAnnouncementBanner?.nodes && !data?.allBlockContentAnnouncementBanner?.nodes[0]) return null
  const announcement = data?.allBlockContentAnnouncementBanner?.nodes[0]
  const enabled = announcement?.field_announcement_
  const content = announcement?.field_announcement_con
  const link = announcement?.field_announcement_external_link?.uri
  const linkLabel = announcement?.field_announcement_link_label
  return (
    <>
      {enabled && !acceptedCookies ?
        <div className={`relative bg-red print:hidden`}>
          <div className="container py-2">
            <p className="md:text-center mr-6 leading-snug" style={{ marginBottom: "0" }}>
              {content ? <span className="font-bold text-white font-body sm:text-lg mr-2">
                {content}
              </span> : null}
              {(link && linkLabel) ?
                <>
                  {link?.startsWith("https://nevadafund.org/")
                    ? <Link to={link} className={"text-white inline-block underline hover:text-white/75"}>{linkLabel}</Link>
                    : <a href={link} target="_blank" rel="noreferrer" className="text-white inline-block underline hover:text-white/75">{linkLabel}</a>}
                </>
                : null}
            </p>
            <div className="absolute inset-y-0 right-0 flex items-center z-10">
              <button
                type="button"
                className="flex rounded-md p-2 mr-2 text-white hover:bg-white/5 focus:outline-none focus:ring-2 focus:ring-white"
                onClick={() => onAcceptCookies()}
              ><span className="sr-only">Dismiss</span>
                <FiX className="block text-xl" aria-hidden={true} />
              </button>

            </div>
          </div>
        </div>

        : null
      }
    </>
  )
}
